
import './App.css';
import { Outlet } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';


function App() {
  return (
    <div className="App">
      <CssBaseline/>
      <Outlet/>
    </div>
  );
}

export default App;
